<div>

	<!--page title-->
	<h1 class="page_title">
		<mat-icon>person</mat-icon>
		<span>
			<span>Profilo</span>
			<small>Informazioni account e impostazioni.</small>
		</span>
	</h1>

	<!--page content-->
	<div class="page_content">
		<div class="inner" *ngIf="user">

			<!--personal info-->
			<div class="mb-6">
				<h2 class="flex items-center mb-2">
					<span>{{'Modules.Settings.PersonalData.Title' | translate}}</span>
				</h2>
				<ul class="settings_list mt-4">
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.FirstName' | translate}}:</strong>
						<span>{{user.firstName}}</span>
					</li>
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.LastName' | translate}}:</strong>
						<span>{{user.lastName}}</span>
					</li>
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.Email' | translate}}:</strong>
						<span>{{user.email}}</span>
					</li>
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.Language' | translate}}:</strong>
						<span>{{user.language}}</span>
					</li>
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.Username' | translate}}:</strong>
						<span>{{user.username}}</span>
					</li>
					<li>
						<strong>{{'Modules.Settings.PersonalData.Form.PasswordExpiration' | translate}}:</strong>
						<span>{{user.passwordExpiration | date:'dd/MM/yyyy'}}</span>
					</li>
				</ul>
			</div>

			<!--change language-->
			<div class="mb-6" *ngIf="languages && languages.length > 1">
				<h2 class="flex items-center mb-2">
					<mat-icon class="mr-2">translate</mat-icon>
					<span>{{'Modules.Settings.Language.Title' | translate}}</span>
				</h2>
				<form [formGroup]="form" class="webapp-form">
					<mat-form-field floatLabel="always">
						<select matNativeControl formControlName="languageCode" (change)="switchLanguage()">
							<option *ngFor="let language of languages" [value]="language.code">
								{{language.name}}
							</option>
						</select>
					</mat-form-field>
				</form>
			</div>

			<!--two factor authentication-->
			<div class="mb-6">
				<h2 class="flex items-center mb-2">
					<span>{{'Modules.Profile.Authenticator.Title' | translate}}</span>
				</h2>

				<!--tfa enabled-->
				<ng-container *ngIf="showTFAConfiguration">
					<ul class="list-none mt-4 text-sm">
						<li class="flex items-center mb-2">
							<span class="flex items-center justify-center rounded-full bg-secondary text-accent text-center min-w-[30px] h-[30px] mr-2">1</span>
							{{'Modules.Profile.Authenticator.TFAEnable1' | translate}}
						</li>
						<li class="flex items-center mb-2">
							<span class="flex items-center justify-center rounded-full bg-secondary text-accent text-center min-w-[30px] h-[30px] mr-2">2</span>
							{{'Modules.Profile.Authenticator.TFAEnable2' | translate}}
						</li>
						<li class="flex items-center mb-2">
							<span class="flex items-center justify-center rounded-full bg-secondary text-accent text-center min-w-[30px] h-[30px] mr-2">3</span>
							{{'Modules.Profile.Authenticator.TFAEnable3' | translate}}
						</li>
					</ul>
					<div class="mt-2">

						<!--qr code-->
						<div class="flex items-center">
							<div>
								<strong>{{'Modules.Profile.Authenticator.SecretKey' | translate}}:</strong>
								<div class="text-xs">{{userTFA.authenticatorKey}}</div>
							</div>
							<button type="button" color="accent" mat-icon-button class="ml-1 "
									matTooltip="{{'Modules.Profile.Tooltips.TFACopyCode' | translate}}"
									(click)="copyAuthenticatorKey()"
									matTooltipPosition="above">
								<mat-icon>content_copy</mat-icon>
							</button>
						</div>

						<!--partners logo-->
						<div class="mt-5">
							<div class="flex items-center justify-between py-2 px-3 border border-solid border-neutral-200 rounded-full">
								<div class="flex flex-1 items-center">
									<img src="/assets/img/shared/microsoft-authenticator.png" class="h-[24px]" />
									<span class="text-sm ml-2">Microsoft Auth.</span>
								</div>
								<div class="flex items-center ml-4">
									<a href="https://apps.apple.com/it/app/microsoft-authenticator/id983156458" target="_blank" matTooltip="App Store">
										<img src="/assets/img/shared/app-store.png" class="h-[24px]" />
									</a>
									<a href="https://play.google.com/store/apps/details?id=com.azure.authenticator" target="_blank" class="ml-4" matTooltip="Google Play">
										<img src="/assets/img/shared/google-play.png" class="h-[24px]" />
									</a>
								</div>
							</div>
							<div class="flex items-center justify-between mt-3 py-2 px-3 border border-solid border-neutral-200 rounded-full">
								<div class="flex flex-1 items-center">
									<img src="/assets/img/shared/google-authenticator.png" class="h-[24px]" />
									<span class="text-sm ml-2">Google Auth.</span>
								</div>
								<div class="flex items-center ml-4">
									<a href="https://apps.apple.com/it/app/google-authenticator/id388497605" target="_blank" matTooltip="App Store">
										<img src="/assets/img/shared/app-store.png" class="h-[24px]" />
									</a>
									<a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" class="ml-4" matTooltip="Google Play">
										<img src="/assets/img/shared/google-play.png" class="h-[24px]" />
									</a>
								</div>
							</div>
						</div>
					</div>

					<!--disable tfa-->
					<div class="flex justify-start mt-6" *ngIf="showTFAConfiguration">
						<button type="button" mat-stroked-button (click)="hideUserTFA()" class="px-6 mr-4" *ngIf="!userTFA.isTFAEnabled">
							{{'Commons.Actions.Cancel' | translate}}
						</button>
						<button type="button" mat-flat-button color="accent" (click)="toggleTFA()" class="px-6">
							<ng-container *ngIf="!userTFA.isTFAEnabled">{{'Modules.Profile.Actions.EnableTFA' | translate}}</ng-container>
							<ng-container *ngIf="userTFA.isTFAEnabled">{{'Modules.Profile.Actions.DisableTFA' | translate}}</ng-container>
						</button>
					</div>
				</ng-container>

				<!--tfa disabled-->
				<div class="mt-3 text-sm" *ngIf="!showTFAConfiguration">
					<div>{{'Modules.Profile.Authenticator.TFADisable' | translate}}</div>
					<button type="button" mat-flat-button color="accent" (click)="showUserTFA()" class="mt-4 px-6">
						{{'Modules.Profile.Actions.VerifyTFA' | translate}}
					</button>
				</div>
			</div>

			<!--push notifications-->
			<div class="mb-6">
				<h2 class="flex items-center mb-2">
					<span>{{'Modules.Settings.PushNotifications.Title' | translate}}</span>
				</h2>
				<div class="mt-3 text-sm">
					<div *ngIf="user.pushNotifications">
						<div>{{'Modules.Settings.PushNotifications.Enabled' | translate}}</div>
						<button *ngIf="user.pushNotifications" (click)="togglePushNotifications(false)" mat-flat-button color="accent" class="mt-4 my-1 px-6">
							{{'Modules.Settings.PushNotifications.Disable' | translate}}
						</button>
					</div>
					<div *ngIf="!user.pushNotifications">
						<div>{{'Modules.Settings.PushNotifications.Disabled' | translate}}</div>
						<button *ngIf="!user.pushNotifications" (click)="togglePushNotifications(true)" mat-flat-button color="accent" class="mt-4 my-1 px-6">
							{{'Modules.Settings.PushNotifications.Enable' | translate}}
						</button>
					</div>
				</div>
			</div>

			<hr />

			<!--logout-->
			<button (click)="logout()" mat-stroked-button color="warn" class="h-8 mt-2 px-6">
				<mat-icon class="mr-2">logout</mat-icon>{{'Modules.Settings.Logout.Button' | translate}}
			</button>

		</div>
	</div>

</div>